import React from "react";
import { useParams } from "react-router-dom";
import { Button, Select as FlowbiteSelect, TextInput } from "flowbite-react";
import Select from "react-select";
import {
  useCreateClusterMutation,
  useGetAllCoursesQuery,
  useGetClustersByCampusQuery,
  useGetClusterQuery,
} from "../../../../graphql/generated.tsx";

const ClusterStep = ({
  formData,
  setFormData,
  prevStep,
  nextStep,
  campusDetails,
  setClusterId,
}) => {
  const { data } = useGetClustersByCampusQuery({
    variables: { campusName: campusDetails?.campus?.name, limit : 200 },
  });

  const { data: ClusterData } = useGetClusterQuery({
    variables: {
      campusName: campusDetails?.campus?.name,
      clusterId: formData.existingCluster,
    },
    skip: !formData.existingCluster || !campusDetails?.campus?.name,
  });
  const { id } = useParams();
  const [createCluster] = useCreateClusterMutation();
  const { data: coursesData } = useGetAllCoursesQuery();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (name === "newCluster" && value) {
      setFormData((prev) => ({ ...prev, existingCluster: "" }));
    }
    if (name === "existingCluster" && value) {
      setFormData((prev) => ({ ...prev, newCluster: "" }));
    }
  };

  const handleCoursesChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      selectedCourses: selectedOptions.map((option) => option.value),
    }));
  };

  const handleSubmit = async () => {
    let clusterId = formData.existingCluster;
    let clusterName = "";

    if (formData.newCluster) {
      const response = await createCluster({
        variables: {
          createClusterInput: {
            name: formData.newCluster,
            campusName: campusDetails.campus.name,
            courseIds: formData.selectedCourses,
          },
        },
      });
      clusterId = response.data.createCluster.id;
      setClusterId(clusterId);
      clusterName = formData.newCluster;
    } else {
      const selectedCluster = data?.getClustersByCampus?.find(
        (cluster) => cluster.id === formData.existingCluster
      );
      clusterName = selectedCluster ? selectedCluster.name : "";
    }

    setFormData((prev) => ({ ...prev, clusterName }));

    const updatedStudents = formData.students.map((student) => ({
      ...student,
      clusterIds: [clusterId],
      campusId: id,
      courseIds: formData.selectedCourses || ClusterData?.getCluster?.courseIds,
    }));

    setClusterId(clusterId);
    setFormData((prev) => ({ ...prev, students: updatedStudents }));

    nextStep();
  };

  const coursesOptions = coursesData?.getAllCourses?.map((course) => ({
    value: course.id,
    label: course.name,
  }));
  // console.log(data.getClustersByCampus);
  

  return (
    <div className="flex flex-col flex-1 min-h-0 w-full h-full pt-0.5">
      <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain pe-1">
        <form className="flex flex-col w-full gap-3">
          <div className="w-full">
            <TextInput
              type="text"
              name="newCluster"
              value={formData.newCluster || ""}
              onChange={handleInputChange}
              placeholder="Enter new cluster name"
              disabled={!!formData.existingCluster}
            />
          </div>
          {!!formData.newCluster && (
            <div className="w-full">
              <Select
                isMulti
                options={coursesOptions}
                onChange={handleCoursesChange}
                placeholder="Select courses"
              />
            </div>
          )}
          <p className="text-center text-gray-500 text-sm">------------ or ------------</p>
          <div className="w-full">
            <FlowbiteSelect
              name="existingCluster"
              value={formData.existingCluster || ""}
              onChange={handleInputChange}
              disabled={!!formData.newCluster}
            >
              <option value="">Select existing cluster</option>
              {data?.getClustersByCampus?.map((cluster) => (
                <option key={cluster.id} value={cluster.id}>
                  {cluster.name}
                </option>
              ))}
            </FlowbiteSelect>
          </div>
        </form>
      </div>
      <div className="flex justify-between w-full gap-2 shrink-0 pt-4 border-t border-gray-100 mt-auto">
        <Button size="sm" className="bg-primary px-3 font-semibold shrink-0" onClick={prevStep}>
          Prev
        </Button>
        <Button
          size="sm"
          className="px-3 font-semibold shrink-0 bg-gray-500 enabled:hover:bg-gray-600"
          onClick={handleSubmit}
          disabled={
            !formData.selectedCourses?.length &&
            !formData.existingCluster?.length
          }
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default ClusterStep;
